<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>
                        G H Raisoni Memorial Amravati District Badminton Championship
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center mb-5">
            <h2><span> G H Raisoni Memorial Amravati District Badminton Championship 2025</span></h2>
        </div>
        <p>The G H Raisoni Memorial District Badminton Championship 2025 concluded with an inspiring prize distribution ceremony, celebrating the exceptional performance and sportsmanship of young athletes. Winners were honored for their dedication, discipline, and determination.</p>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>

                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>

            </ul>
        </div>
    </div>
</section>
